import './styles.scoped.css'
import {Typography, Button, IconButton, Modal, Avatar} from '@mui/material'
import {Close, DateRange} from '@mui/icons-material'
import {useMobile} from '../../hooks'
import {getColorFromName, getInitials, ignoreTimezone, parseError} from '../../utils/helpers'
import {format} from 'date-fns'
import {scheduleApi} from '../../services'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'

// Deletes the whole schedule behind a visit (DELETE /schedules/{id}), as opposed to
// DeleteVisits, which removes individual occurrences. The server refuses a schedule
// that has history or is cancelled; its message is shown as-is.
const REFUSED = {
    SCHEDULE_HAS_HISTORY: 'Schedule Not Deleted',
    SCHEDULE_CANCELLED: 'Schedule Not Deleted',
}

const dateLabel = value => format(new Date(ignoreTimezone(value)), 'dd MMM yyyy')

export default ({open, setOpen, onDeleted, item}) => {
    const {mobile} = useMobile()
    const {setLoading, setMessageBox, branchId} = useGlobalStates()

    const client = item?.schedule?.client
    const clientName = client?.first_name + ' ' + client?.last_name
    const serviceName = item?.schedule?.service?.name ?? item?.schedule?.service_agreement_item?.service_name
    const startDate = item?.schedule?.start_date
    const endDate = item?.schedule?.end_date

    const submit = () => {
        setLoading(true)
        scheduleApi
            .deleteSchedule(branchId, item?.schedule_id)
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Schedule Successfully Deleted',
                    description: `The schedule for ${clientName} and all of its visits have been deleted.`,
                })
                onDeleted?.()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title: REFUSED[title] ?? title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    {mobile ? (
                        <>
                            <div className="header">
                                <Typography variant="h6" color="text.primary">
                                    Are you sure you want to delete this schedule?
                                </Typography>
                                <IconButton onClick={() => setOpen(false)}>
                                    <Close />
                                </IconButton>
                            </div>
                            <div className="actions">
                                <Button variant="outlined" onClick={() => setOpen(false)} style={{flex: 1}}>
                                    Back
                                </Button>
                                <Button variant="contained" color="error" fullWidth onClick={submit} style={{flex: 1}}>
                                    Delete Schedule
                                </Button>
                            </div>
                            <br />
                            <br />
                            <br />
                        </>
                    ) : (
                        <Typography variant="h6" color="text.primary" className="title">
                            Are you sure you want to delete this schedule?
                        </Typography>
                    )}
                    <br />
                    <Typography variant="body2" color="text.primary" className="title">
                        This deletes the whole schedule and all of its visits, not only this one. It cannot be undone.
                    </Typography>
                    <br />
                    <Typography variant="body2" color="text.secondary" className="title">
                        A schedule that already has visit history cannot be deleted. End it by setting an end date instead.
                    </Typography>
                    <br />
                    <div className="card">
                        <div className="people-card">
                            {client?.avatar_url ? (
                                <Avatar src={client.avatar_url} style={{width: 40, height: 40}} />
                            ) : (
                                <Avatar style={{backgroundColor: getColorFromName(clientName), width: 40, height: 40, fontSize: 20}}>
                                    {getInitials(clientName)}
                                </Avatar>
                            )}
                            <div className="people-profile-card">
                                <Typography variant="h8" color="text.primary" className="name">
                                    {clientName}
                                </Typography>
                                <Typography variant="body3" color="text.secondary" className="name">
                                    {serviceName}
                                </Typography>
                            </div>
                        </div>
                        {startDate && (
                            <>
                                <br />
                                <div className="datetime">
                                    <div className="row-content">
                                        <Typography variant="body3" color="text.secondary">
                                            <DateRange fontSize="small" />
                                        </Typography>
                                        <Typography variant="body3" color="text.secondary">
                                            {endDate
                                                ? `${dateLabel(startDate)} - ${dateLabel(endDate)}`
                                                : `From ${dateLabel(startDate)}, no end date`}
                                        </Typography>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <br />
                    {mobile ? (
                        <>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    ) : (
                        <div className="actions">
                            <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                                Cancel
                            </Button>
                            <Button variant="contained" color="error" fullWidth onClick={submit}>
                                Delete Schedule
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    )
}
